import React, { useContext } from 'react';
import { AddEditFolderModal } from '../AddEditFolderModal';
import { DeleteFolderModal } from '../DeleteFolderModal';
import { AddEditSourceModal } from '../AddEditSourceModal';
import { DeleteSourceModal } from '../DeleteSourceModal';
import { TreeMenuModalTypeEnums } from '../../../../constants/find-content';
import { TreeMenuContext } from '../TreeMenu/TreeMenuProvider';

export const TreeMenuModalsView = (): JSX.Element => {
  const { modalType, closeHandler } = useContext(TreeMenuContext);

  return (
    <div>
      {(() => {
        switch (modalType) {
          case TreeMenuModalTypeEnums.ADD_FOLDER:
          case TreeMenuModalTypeEnums.RENAME_FOLDER:
            return <AddEditFolderModal />;
          case TreeMenuModalTypeEnums.DELETE_FOLDER:
            return <DeleteFolderModal />;
          case TreeMenuModalTypeEnums.RENAME_SOURCE:
            return <AddEditSourceModal closeModalHandler={closeHandler} />;
          case TreeMenuModalTypeEnums.DELETE_SOURCE:
            return <DeleteSourceModal />;
        }
      })()}
    </div>
  );
};
